import React from 'react';

/** Decorative flags + CSS fireworks for Independence Day notices */
const IndependenceDayDecor = () => (
  <div className="independence-decor" aria-hidden="true">
    <div className="independence-flags">
      <span className="independence-flag independence-flag--left" title="">
        <span className="independence-flag__pole" />
        <span className="independence-flag__cloth">
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__stripe" />
          <span className="independence-flag__canton" />
        </span>
      </span>
    </div>
    <div className="independence-fireworks">
      <span className="independence-firework independence-firework--1" />
      <span className="independence-firework independence-firework--2" />
      <span className="independence-firework independence-firework--3" />
    </div>
  </div>
);

export default IndependenceDayDecor;
